import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", null, "Dados do formulário", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("article", null, [
    _hoisted_1,
    _createVNode(_component_ckeditor, {
      editor: _ctx.classicEditor,
      modelValue: _ctx.editorHtml,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editorHtml) = $event)),
      config: {}
    }, null, 8, ["editor", "modelValue"]),
    _createTextVNode(" " + _toDisplayString(_ctx.editorHtml), 1)
  ]))
}